import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Mousewheel, Navigation, Pagination } from "swiper/modules";
import pic2 from "../../assests/img/pic2.png";
import banner from "../../assests/img/banner.jpg";
import shape3 from "../../assests/img/shape3.png";
import pic1 from "../../assests/img/pic1.png";
import founder from "../../assests/img/founder.jpg";
import director from "../../assests/img/director.jpg";
import patron from "../../assests/img/patron.jpg";
import patron2 from "../../assests/img/patron2.jpg";

const Home = () => {
  return (
    <>
      <div className="inner_home">
        <div className="slider_sec">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            freeMode={true}
            modules={[Navigation, Pagination, Mousewheel, Autoplay]}
            breakpoints={{
              240: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              576: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
            }}
            pagination={{
              clickable: true,
            }}
            mousewheel={{
              forceToAxis: true,
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="">
                <img
                  src="https://kcmschoolbass.com/templates/kcm-school/images/slider1.jpg "
                  alt="banner"
                  width="100%"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="">
                <img
                  src="https://kcmschoolbass.com/templates/kcm-school/images/slider2.jpg"
                  alt="banner"
                  width="100%"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="">
                <img
                  src="https://kcmschoolbass.com/templates/kcm-school/images/slider3.jpg"
                  alt="banner"
                  width="100%"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="coustom_container">
          <section className="content-inner section-wrapper4">
            <Row>
              <Col xl={5} lg={6} className="wow fadeInUp" data-wow-delay="0.2s">
                <div
                  className="donate-form form-wrapper"
                  style={{
                    backgroundImage:
                      "url('https://kcmschoolbass.com/templates/kcm-school/images/background/bg2.jpg')",
                  }}
                >
                  <div className="donate-info">
                    <h2 className="title m-b20">Latest News</h2>
                    <marquee
                      scrollamount="2"
                      id="news"
                      onmouseover="javascript:news.stop();"
                      onmouseout="javascript:news.start();"
                      behavior="scroll"
                      direction="up"
                      height="280px"
                      width="100%;"
                    >
                      <ul>
                        <li style={{ listStyleType: "none" }}>
                          <a
                            className="marqueeV1"
                            href="online-registration"
                            target="_blank"
                          >
                            Admission Open for session 2025-26 (Apply Now)
                          </a>
                          <br />
                          <img
                            src="https://kcmschoolbass.com/images/new-y.gif"
                            border="0"
                          />
                        </li>
                      </ul>
                    </marquee>
                  </div>
                </div>
              </Col>
              <Col
                xl={7}
                lg={6}
                className="m-b30 wow fadeInUp"
                data-wow-delay="0.4s"
              >
                <div className="section-inner">
                  <div className="section-head m-b30">
                    <h5 className="sub-title">Karamchand Memorial School</h5>
                    <h2 className="title">Welcome</h2>
                  </div>
                  <div className="m-b30">
                    <p>
                      We are a young and budding educational institution who
                      believe in domestic system in education, and not in the
                      mechanical methods of large production in institutions
                      turning students into standardised articles.
                    </p>
                    <p>
                      We believe the making of a man depends on the human
                      factors. It depends on individual attention and treatment
                      to be given by the teacher. In consonance with the
                      Upanishadic idea, individual is the chief concern and
                      centre of our education, and education also is necessarily
                      individual centric.
                    </p>
                  </div>
                  <a href="#" className="btn btn-primary read_more_btn">
                    Read More
                  </a>
                </div>
              </Col>
            </Row>
            <img className="img-111" src={pic2} alt="images" />
          </section>
        </div>

        <div className="coustom_container">
          <section className="clearfix section-wrapper7">
            <div className="content-inner bg-gray/ section-inner" style={{}}>
              <div
                className="section-head text-center wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <h5 className="sub-title">Our Infrastructure</h5>
                <h2 className="mb-4">Facilities @ KCM</h2>
              </div>
              <div className="slider_sec">
                <Swiper
                  slidesPerView={3}
                  spaceBetween={30}
                  freeMode={true}
                  modules={[Navigation, Mousewheel, Autoplay]}
                  breakpoints={{
                    240: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    576: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  mousewheel={{
                    forceToAxis: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <Card style={{ borderRadius: 10 }}>
                      <Card.Body style={{ padding: 0 }}>
                        <div className="card_bg">
                          <img
                            src={banner}
                            alt="banner"
                            width="100%"
                            style={{ borderRadius: "10px 10px 0 0" }}
                          />
                          <div style={{ padding: "15px 15px 20px" }}>
                            {/* <span>Computer Lab</span> */}
                            <h4>Computer Lab</h4>
                            <p>
                              The school integrates Information and
                              Communication technology into the curriculum, and
                              thus provides the latest resources.
                            </p>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#read"
                              style={{ color: "#D54400" }}
                            >
                              Read More →
                            </a>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Card style={{ borderRadius: 10 }}>
                      <Card.Body style={{ padding: 0 }}>
                        <div className="card_bg">
                          <img
                            src={banner}
                            alt="banner"
                            width="100%"
                            style={{ borderRadius: "10px 10px 0 0" }}
                          />
                          <div style={{ padding: "15px 15px 20px" }}>
                            {/* <span>Computer Lab</span> */}
                            <h4>Computer Lab</h4>
                            <p>
                              The school integrates Information and
                              Communication technology into the curriculum, and
                              thus provides the latest resources.
                            </p>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#read"
                              style={{ color: "#D54400" }}
                            >
                              Read More →
                            </a>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Card style={{ borderRadius: 10 }}>
                      <Card.Body style={{ padding: 0 }}>
                        <div className="card_bg">
                          <img
                            src={banner}
                            alt="banner"
                            width="100%"
                            style={{ borderRadius: "10px 10px 0 0" }}
                          />
                          <div style={{ padding: "15px 15px 20px" }}>
                            {/* <span>Computer Lab</span> */}
                            <h4>Computer Lab</h4>
                            <p>
                              The school integrates Information and
                              Communication technology into the curriculum, and
                              thus provides the latest resources.
                            </p>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#read"
                              style={{ color: "#D54400" }}
                            >
                              Read More →
                            </a>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Card style={{ borderRadius: 10 }}>
                      <Card.Body style={{ padding: 0 }}>
                        <div className="card_bg">
                          <img
                            src={banner}
                            alt="banner"
                            width="100%"
                            style={{ borderRadius: "10px 10px 0 0" }}
                          />
                          <div style={{ padding: "15px 15px 20px" }}>
                            {/* <span>Computer Lab</span> */}
                            <h4>Computer Lab</h4>
                            <p>
                              The school integrates Information and
                              Communication technology into the curriculum, and
                              thus provides the latest resources.
                            </p>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#read"
                              style={{ color: "#D54400" }}
                            >
                              Read More →
                            </a>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Card style={{ borderRadius: 10 }}>
                      <Card.Body style={{ padding: 0 }}>
                        <div className="card_bg">
                          <img
                            src={banner}
                            alt="banner"
                            width="100%"
                            style={{ borderRadius: "10px 10px 0 0" }}
                          />
                          <div style={{ padding: "15px 15px 20px" }}>
                            {/* <span>Computer Lab</span> */}
                            <h4>Computer Lab</h4>
                            <p>
                              The school integrates Information and
                              Communication technology into the curriculum, and
                              thus provides the latest resources.
                            </p>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#read"
                              style={{ color: "#D54400" }}
                            >
                              Read More →
                            </a>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Card style={{ borderRadius: 10 }}>
                      <Card.Body style={{ padding: 0 }}>
                        <div className="card_bg">
                          <img
                            src={banner}
                            alt="banner"
                            width="100%"
                            style={{ borderRadius: "10px 10px 0 0" }}
                          />
                          <div style={{ padding: "15px 15px 20px" }}>
                            {/* <span>Computer Lab</span> */}
                            <h4>Computer Lab</h4>
                            <p>
                              The school integrates Information and
                              Communication technology into the curriculum, and
                              thus provides the latest resources.
                            </p>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#read"
                              style={{ color: "#D54400" }}
                            >
                              Read More →
                            </a>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Card style={{ borderRadius: 10 }}>
                      <Card.Body style={{ padding: 0 }}>
                        <div className="card_bg">
                          <img
                            src={banner}
                            alt="banner"
                            width="100%"
                            style={{ borderRadius: "10px 10px 0 0" }}
                          />
                          <div style={{ padding: "15px 15px 20px" }}>
                            {/* <span>Computer Lab</span> */}
                            <h4>Computer Lab</h4>
                            <p>
                              The school integrates Information and
                              Communication technology into the curriculum, and
                              thus provides the latest resources.
                            </p>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#read"
                              style={{ color: "#D54400" }}
                            >
                              Read More →
                            </a>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </section>
        </div>

        <section className="content-inner-1 section-wrapper3">
          <div className="coustom_container">
            <div
              className="section-head text-center wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h6 className="sub-title">Student Corner</h6>
              <h2 className="title">More @ KCM</h2>
            </div>
            <Row className="justify-content-center">
              <Col lg={4} md={6} className="wow fadeInUp" data-wow-delay="0.2s">
                <div className="icon-bx-wraper text-center style-5 m-b30">
                  <div className="icon-lg m-b30">
                    <a href="online-registration" className="icon-cell">
                      <img
                        src="https://kcmschoolbass.com/templates/kcm-school/images/icon/admission.png"
                        alt=""
                        border="0"
                      />
                    </a>
                    <div className="badge">01</div>
                  </div>
                  <div className="icon-content">
                    <h5 className="title">Admission 2025-26</h5>
                    <p>
                      Parents and Guardians who are interested for the admission
                      of their children in Karamchand Memorial School have to
                      register.
                    </p>
                    <a href="online-registration.html">click here →</a>
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6} className="wow fadeInUp" data-wow-delay="0.4s">
                <div className="icon-bx-wraper text-center style-5 m-b30">
                  <div className="icon-lg m-b30">
                    <a href="gallery" className="icon-cell">
                      <img
                        src="https://kcmschoolbass.com/templates/kcm-school/images/icon/gallery.png"
                        alt=""
                        border="0"
                      />
                    </a>
                    <div className="badge">02</div>
                  </div>
                  <div className="icon-content">
                    <h5 className="title">Photogallery</h5>
                    <p>
                      Want to see Karamchand Memorial School photogallery
                      cultural events? Check out the gallery by clicking here.
                    </p>
                    <a href="gallery">click here →</a>
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6} className="wow fadeInUp" data-wow-delay="0.6s">
                <div className="icon-bx-wraper text-center style-5 m-b30">
                  <div className="icon-lg m-b30">
                    <a href="downloads" className="icon-cell">
                      <img
                        src="https://kcmschoolbass.com/templates/kcm-school/images/icon/download.png"
                        alt=""
                        border="0"
                      />
                    </a>
                    <div className="badge">03</div>
                  </div>
                  <div className="icon-content">
                    <h5 className="title">Downloads</h5>
                    <p>
                      On this page you have access to download free material to
                      help you with your study.
                    </p>
                    <a href="downloads">click here →</a>
                  </div>
                </div>
              </Col>
            </Row>
            <img src={pic1} alt="images" className="img-1" />
            <img src={shape3} alt="images" className="img-2" />
          </div>
        </section>

        <section className="content-inner testimonial-wrapper2">
          <div className="coustom_container">
            <div
              className="section-head text-center wow fadeInUp"
              data-wow-delay="0.8s"
            >
              <h5 className="sub-title">Karamchand Memorial School</h5>
              <h2 className="title">Messages form the Desk</h2>
            </div>
          </div>
          <div className="coustom_container">
            <div className="min-container position-relative">
              <Swiper
                slidesPerView={3}
                spaceBetween={30}
                freeMode={true}
                modules={[Navigation, Mousewheel, Autoplay]}
                breakpoints={{
                  240: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  576: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                }}
                pagination={{
                  clickable: true,
                }}
                mousewheel={{
                  forceToAxis: true,
                }}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                className="mySwiper"
              >
                <SwiperSlide>
                  <div
                    className="testimonial-2 wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="testimonial-media">
                      <img src={founder} alt="founder" />
                    </div>
                    <div className="testimonial-content">
                      <h3 className="testimonial-title">Founder's Message</h3>
                      <p className="testimonial-text text-dark">
                        I warmly welcome you to Karamchand Memorial School,
                        where you will discover a very special, inclusive and
                        friendly community. Every child in our care will be an
                        individual. We aim to uphold the values of building
                        self-esteem and self-belief in a very supportive and
                        kind atmosphere.
                        <br />
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#read"
                        >
                          Read More →
                        </a>
                      </p>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div
                    className="testimonial-2 wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="testimonial-media">
                      <img src={director} alt="director" />
                    </div>
                    <div className="testimonial-content">
                      <h3 className="testimonial-title">Director's Message</h3>
                      <p className="testimonial-text text-dark">
                        Welcome to Karamchand Memorial School, a nascent and
                        budding yet passionate, purposeful and progressive place
                        to study, where our pupils will discover a deep love for
                        learning and respect for the tradition of scholarship,
                        as well as an openness to fresh ideas.
                        <br />
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#read"
                        >
                          Read More →
                        </a>
                      </p>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div
                    className="testimonial-2 wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="testimonial-media">
                      <img src={patron} alt="patron" />
                    </div>
                    <div className="testimonial-content">
                      <h3 className="testimonial-title">Patron's Message</h3>
                      <p className="testimonial-text text-dark">
                        At Karamchand Memorial School we envision education as a
                        powerful instrument for the enlightenment and
                        empowerment of our citizens. It is from this spirit that
                        we draw our educational goal of empowering students to
                        become self-dependent with a global outlook.
                        <br />
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#read"
                        >
                          Read More →
                        </a>
                      </p>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div
                    className="testimonial-2 wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="testimonial-media">
                      <img src={patron2} alt="patron2" />
                    </div>
                    <div className="testimonial-content">
                      <h3 className="testimonial-title">Patron's Message</h3>
                      <p className="testimonial-text text-dark">
                        Education is essentially the process of transformation
                        of an individual to enhance the ability to meet the
                        expected or unexpected situations of life. It is the
                        continuous process of learning. Learning indeed is
                        understanding of new things in a billion ways.
                        <br />
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#read"
                        >
                          Read More →
                        </a>
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                {/* <div className="swiper-btn swiper-btn-center-lr">
                <div className="test-swiper-prev btn-prev style-2">
                  <i className="flaticon-left-arrow-1"></i>
                </div>
                <div className="test-swiper-next btn-next style-2">
                  <i className="flaticon-next"></i>
                </div>
              </div> */}
              </Swiper>
            </div>
          </div>
        </section>

        <section className="content-inner-2">
          <div className="coustom_container">
            <Row>
              <Col xl={12} lg={12}>
                <div
                  className="dz-card style-6 blog-half wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="dz-media">
                    <a href="our-aims">
                      <img
                        src="https://kcmschoolbass.com/templates/kcm-school/images/mission.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="dz-info">
                    <h4 className="dz-title">
                      <a href="#">Our Aims</a>
                    </h4>
                    <p>
                      We aim to provide an outstanding skills-based, broad and
                      creative education which opens up a world of possibilities
                      and inspires a love of learning in every child.
                      Independence, critical thinking, the ability to exercise
                      choice and to engage in self-evaluation and reflection are
                      important.
                    </p>
                    <a href="our-aims">Read →</a>
                  </div>
                </div>
              </Col>
              <Col xl={12} lg={12}>
                <div
                  className="dz-card style-6 blog-half wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="dz-media">
                    <a href="our-vision">
                      <img
                        src="https://kcmschoolbass.com/templates/kcm-school/images/vision.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="dz-info">
                    <h4 className="dz-title">
                      <a href="our-vision.html">OUR VISION</a>
                    </h4>
                    <p>
                      Through Karamchand Memorial School we envision to create a
                      community of eternal learners, with sound ethical moorings
                      and values; who have in them the unfaltering notion of
                      nationalism and patriotism, who have a sound, unbiased and
                      unadulterated understanding of our glorious past and who
                      are enlightened, innovative, and solicitous global
                      citizens.
                    </p>
                    <a href="our-vision">Read →</a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
